import { Inject } from 'inversify-props'
import type { CarrinhoServiceAdapter } from './adapter/CarrinhoServiceAdapter'
import { Carrinho, CarrinhoPublico } from '@/models/venda/Carrinho'
import { AxiosRequestConfig } from 'axios'
import { Page, Venda } from '@/models'

export class FindCarrinhoUseCase {
	@Inject('CarrinhoServiceAdapter')
	private carrinhoServiceAdapter!: CarrinhoServiceAdapter

	criarCarrinho = async (carrinho: Carrinho): Promise<Carrinho> =>
		await this.carrinhoServiceAdapter.criarCarrinho(carrinho)

	atualizarCarrinho = async (carrinho: Carrinho): Promise<Carrinho> =>
		await this.carrinhoServiceAdapter.atualizarCarrinho(carrinho)

	findCarrinhosByTipo = async (params: any, config?: AxiosRequestConfig): Promise<Page<Carrinho>> =>
		await this.carrinhoServiceAdapter.findCarrinhosByTipo(params, config)

	findByIdentificador = async (identificador: string): Promise<CarrinhoPublico> =>
		await this.carrinhoServiceAdapter.findByIdentificador(identificador)

	finalizarMalinhaDoCliente = async (carrinho: CarrinhoPublico): Promise<CarrinhoPublico> =>
		await this.carrinhoServiceAdapter.finalizarMalinhaDoCliente(carrinho)

	findVendaPublicDoCarrinho = async (carrinhoId: string, vendedorId: string): Promise<Venda> =>
		await this.carrinhoServiceAdapter.findVendaPublicDoCarrinho(carrinhoId, vendedorId)

	relacionarVendaAoCarrinho = async (vendaId: string, carrinhoId: string): Promise<Carrinho> =>
		await this.carrinhoServiceAdapter.relacionarVendaAoCarrinho(vendaId, carrinhoId)

	removerCarrinho = async (idCarrinho: string): Promise<void> =>
		await this.carrinhoServiceAdapter.removerCarrinho(idCarrinho)

	atualizarTotaisDoCarrinho = async (carrinhoId: string, valorTotal: number, quantidadeDePecas: number): Promise<void> =>
		await this.carrinhoServiceAdapter.atualizarTotaisDoCarrinho(carrinhoId, valorTotal, quantidadeDePecas)
}